import * as React from 'react'

import Svg, {
  ClipPath,
  Defs,
  G,
  LinearGradient,
  Path,
  RadialGradient,
  Stop,
} from 'react-native-svg'

function DigitalSilver(props) {
  return (
    <Svg
      width={41}
      height={42}
      viewBox="0 0 41 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <G clipPath="url(#clip0_1051_86964)">
        <Path
          d="M41.001 25.016c0 .305 0 .705-2.578 4.084a151.361 151.361 0 01-2.467 3.123.622.622 0 01-.496.24c-.065 0-.129 0-.177-.031a.613.613 0 01-.448-.545c-.192-1.842-.48-4.164-1.009-5.797a.59.59 0 01.096-.561l3.716-5.173a.654.654 0 01.544-.272c.208 0 .417.112.529.304.849 1.361 2.29 3.796 2.29 4.628z"
          fill="url(#paint0_linear_1051_86964)"
        />
        <Path
          d="M35.668 32.416s-.064.032-.224.032c-.032 0-.08 0-.112-.016-5.253-.913-10.074-2.323-14.318-4.18a.634.634 0 01-.368-.48.646.646 0 01.192-.577l4.388-4.197a.653.653 0 01.657-.144l.256.08c3.22 1.105 7.159 3.588 8.552 3.492l.977 5.99z"
          fill="url(#paint1_linear_1051_86964)"
        />
        <Path
          d="M38.663 21.077l-3.716 5.173a.647.647 0 01-.48.272h-.208c-1.73 0-5.03-1.137-8.537-2.354l-.256-.096a.672.672 0 01-.416-.465.588.588 0 01.192-.592l5.189-4.95a.628.628 0 01.576-.16c3.556.737 6.183 1.41 7.496 2.259.144.096.256.24.288.416a.689.689 0 01-.128.497z"
          fill="#A5CDFF"
        />
        <Path
          d="M32.481 17.873L21.72 28.14l-.016.015-10.01 8.68a.675.675 0 01-.416.161c-.064 0-.112 0-.177-.032a.66.66 0 01-.432-.416c-.88-2.787-1.25-4.87-1.153-6.567 0-.16.08-.304.192-.416C15.601 23.75 19.83 20.212 24.33 16.48a362.243 362.243 0 003.764-3.155.635.635 0 01.625-.112c1.938.673 2.979 2.37 3.891 3.876a.66.66 0 01-.128.784z"
          fill="url(#paint2_linear_1051_86964)"
        />
        <Path
          d="M4.021 19.411c-.048 0-.096 0-.144-.016l-3.38-.8a.652.652 0 01-.48-.77.652.652 0 01.769-.48l3.38.8c.336.08.56.433.48.77a.62.62 0 01-.625.496z"
          fill="url(#paint3_radial_1051_86964)"
        />
        <Path
          d="M11.084 12.38a.603.603 0 01-.528-.288L8.634 9.193a.64.64 0 01.176-.88.64.64 0 01.881.175l1.906 2.9a.64.64 0 01-.176.88.532.532 0 01-.337.112z"
          fill="url(#paint4_radial_1051_86964)"
        />
        <Path
          d="M32.897 12.684a.789.789 0 01-.32-.08.633.633 0 01-.24-.864l1.697-3.027a.633.633 0 01.865-.24c.304.175.417.56.24.864l-1.697 3.027a.607.607 0 01-.545.32z"
          fill="url(#paint5_radial_1051_86964)"
        />
        <Path
          d="M28.156 10.266c-.032 0-.08 0-.128-.016a.64.64 0 01-.512-.753l.64-3.411a.64.64 0 01.753-.513.64.64 0 01.513.753l-.641 3.412a.621.621 0 01-.625.528z"
          fill="url(#paint6_radial_1051_86964)"
        />
        <Path
          d="M35.988 16.32a.669.669 0 01-.512-.256.641.641 0 01.144-.897l2.803-2.05a.641.641 0 11.752 1.04l-2.802 2.05a.879.879 0 01-.385.113z"
          fill="url(#paint7_radial_1051_86964)"
        />
        <Path
          d="M6.28 14.959a.733.733 0 01-.385-.128l-2.787-2.034a.641.641 0 11.753-1.042l2.787 2.034a.641.641 0 01.144.897.639.639 0 01-.513.273z"
          fill="url(#paint8_radial_1051_86964)"
        />
        <Path
          d="M11.276 36.996a.623.623 0 01-.368-.112c-2.354-1.682-7.864-5.686-8.36-6.663-.609-1.185-.064-4.116.336-5.349a.613.613 0 01.417-.4.621.621 0 01.576.096l6.647 4.933c.176.128-.273.929-.289 1.153-.096 1.537 1.041 6.342 1.041 6.342z"
          fill="url(#paint9_linear_1051_86964)"
        />
        <Path
          d="M28.893 14.286c-1.297 1.105-2.546 2.146-3.748 3.155-4.468 3.732-8.696 7.24-14.558 13.02a.633.633 0 01-.448.193.69.69 0 01-.385-.128l-6.646-4.933a.586.586 0 01-.256-.48.624.624 0 01.208-.513c.048-.032 4.148-3.732 8.392-7.383C20.197 9.69 20.917 9.69 21.35 9.69c1.57 0 6.486 2.962 7.463 3.555a.64.64 0 01.304.497.616.616 0 01-.224.544z"
          fill="#A5CDFF"
        />
      </G>
      <Defs>
        <LinearGradient
          id="paint0_linear_1051_86964"
          x1={39.9519}
          y1={19.1017}
          x2={32.1871}
          y2={27.5942}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#9BC7FE" />
          <Stop offset={1} stopColor="#378CF7" />
        </LinearGradient>
        <LinearGradient
          id="paint1_linear_1051_86964"
          x1={33.4805}
          y1={22.0562}
          x2={29.7769}
          y2={32.9192}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#9BC7FE" />
          <Stop offset={1} stopColor="#378CF7" />
        </LinearGradient>
        <LinearGradient
          id="paint2_linear_1051_86964"
          x1={29.3097}
          y1={11.2849}
          x2={16.6792}
          y2={34.3794}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#9BC7FE" />
          <Stop offset={1} stopColor="#378CF7" />
        </LinearGradient>
        <RadialGradient
          id="paint3_radial_1051_86964"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(-2.872 1.8315 -1.8778 -2.9446 2.699 17.573)"
        >
          <Stop stopColor="#FFEED8" />
          <Stop offset={1} stopColor="#D59A4F" />
        </RadialGradient>
        <RadialGradient
          id="paint4_radial_1051_86964"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(118.04 2.572 7.46) scale(4.15827 3.90188)"
        >
          <Stop stopColor="#FFEED8" />
          <Stop offset={1} stopColor="#D59A4F" />
        </RadialGradient>
        <RadialGradient
          id="paint5_radial_1051_86964"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(115.844 14.2 15.093) scale(4.19835 3.72503)"
        >
          <Stop stopColor="#FFEED8" />
          <Stop offset={1} stopColor="#D59A4F" />
        </RadialGradient>
        <RadialGradient
          id="paint6_radial_1051_86964"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(106.019 12.007 13.837) scale(4.30416 2.58193)"
        >
          <Stop stopColor="#FFEED8" />
          <Stop offset={1} stopColor="#D59A4F" />
        </RadialGradient>
        <RadialGradient
          id="paint7_radial_1051_86964"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(130.737 15.792 15.34) scale(3.86012 4.31672)"
        >
          <Stop stopColor="#FFEED8" />
          <Stop offset={1} stopColor="#D59A4F" />
        </RadialGradient>
        <RadialGradient
          id="paint8_radial_1051_86964"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(130.625 -.164 7.207) scale(3.85368 4.30699)"
        >
          <Stop stopColor="#FFEED8" />
          <Stop offset={1} stopColor="#D59A4F" />
        </RadialGradient>
        <LinearGradient
          id="paint9_linear_1051_86964"
          x1={9.96627}
          y1={23.444}
          x2={2.39728}
          y2={33.6379}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#9BC7FE" />
          <Stop offset={1} stopColor="#378CF7" />
        </LinearGradient>
        <ClipPath id="clip0_1051_86964">
          <Path
            fill="#fff"
            transform="translate(.001 .785)"
            d="M0 0H41V41H0z"
          />
        </ClipPath>
      </Defs>
    </Svg>
  )
}

export default DigitalSilver
